import { Navigate, Outlet } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated, getIsStaff } from "@/src/auth/store/auth-selectors";
import { useAppSelector } from "@/src/common/redux/store";

export function StaffGuard() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const isStaff = useAppSelector(getIsStaff);

	if (!isAuthenticated) return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	if (!isStaff) return <Navigate to="/" replace />;

	return <Outlet />;
}
